/**
 * Маршруты
 */

export enum Routes {
  HOME = 'home',
  DRIVERS = 'drivers',
  DRIVERS_CREATE = '/drivers/create',
  REPORT = '/report',
  BALLONS = '/ballons',
  DRIVERS_EDIT = '/drivers/edit',
  HISTORY = '/history',
  PROFILE = '/profile',
  AUTH = '/auth',
  REGISTRETION = '/registration',
  MAP = '/map',
  WASH_MAP = '/wash-map',
}

/**
 * Шрифты, которые должны быть принудительно предзагружены.
 */
export const fontsForPreload = [
  '100 14px Roboto',
  'italic 100 14px Roboto',
  '300 14px Roboto',
  'italic 300 14px Roboto',
  '14px Roboto',
  'italic 14px Roboto',
  '500 14px Roboto',
  'italic 500 14px Roboto',
  'bold 14px Roboto',
  'italic bold 14px Roboto',
  '900 14px Roboto',
  'italic 900 14px Roboto',
];

export const MAX_UPLOADING_PHOTO_SIZE = 2 * 1024 * 1024; // 2Mb
export const MAX_UPLOADING_DOCUMENT_SIZE = 50 * 1024 * 1024; // 50Mb
